import { cva } from "class-variance-authority";

export const buttonVariants = cva(
  "focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive inline-flex shrink-0 cursor-pointer items-center justify-center gap-2 rounded-md text-sm font-medium whitespace-nowrap transition-all outline-none focus-visible:ring-[3px] disabled:pointer-events-none [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
  {
    variants: {
      variant: {
        default: "",
        outline:
          "bg-background hover:bg-accent dark:bg-input/30 dark:hover:bg-input/50 border shadow-xs",
        ghost: "hover:bg-accent dark:hover:bg-accent/50",
        link: "underline-offset-4 hover:underline",
      },
      size: {
        default: "h-9 px-3 py-2",
        sm: "h-7 gap-1.5 rounded-sm px-1.5 text-xs",
        lg: "h-10 rounded-md px-6 has-[>svg]:px-4",
        icon: "size-9",
        "icon-sm": "size-8",
        "icon-lg": "size-10",
      },
      color: {
        primary: "",
        secondary: "",
        destructive: "",
      },
    },
    compoundVariants: [
      // Default variant - color applies to background
      {
        variant: "default",
        color: "primary",
        class: "bg-primary text-primary-foreground hover:bg-primary/90",
      },
      {
        variant: "default",
        color: "secondary",
        class: "bg-secondary text-secondary-foreground hover:bg-secondary/80",
      },
      {
        variant: "default",
        color: "destructive",
        class:
          "bg-destructive hover:bg-destructive/90 focus-visible:ring-destructive/20 dark:focus-visible:ring-destructive/40 text-white",
      },
      // Outline variant - color applies to border and text
      {
        variant: "outline",
        color: "primary",
        class:
          "text-primary border-primary hover:bg-primary dark:hover:bg-primary hover:text-primary-foreground",
      },
      {
        variant: "outline",
        color: "secondary",
        class:
          "text-foreground border-border hover:bg-secondary dark:hover:bg-secondary hover:text-secondary-foreground",
      },
      {
        variant: "outline",
        color: "destructive",
        class:
          "text-destructive border-destructive hover:bg-destructive dark:hover:bg-destructive focus-visible:ring-destructive/20 dark:focus-visible:ring-destructive/40 hover:text-white",
      },
      // Ghost variant - color applies to text
      {
        variant: "ghost",
        color: "primary",
        class: "text-primary hover:bg-primary dark:hover:bg-primary hover:text-primary-foreground",
      },
      {
        variant: "ghost",
        color: "secondary",
        class:
          "text-foreground hover:bg-secondary dark:hover:bg-secondary hover:text-secondary-foreground",
      },
      {
        variant: "ghost",
        color: "destructive",
        class:
          "text-destructive hover:bg-destructive dark:hover:bg-destructive focus-visible:ring-destructive/20 dark:focus-visible:ring-destructive/40 hover:text-white",
      },
      // Link variant - color applies to text
      {
        variant: "link",
        color: "primary",
        class: "text-primary",
      },
      {
        variant: "link",
        color: "secondary",
        class: "text-foreground",
      },
      {
        variant: "link",
        color: "destructive",
        class: "text-destructive",
      },
      // Disabled variants - different text colors
      {
        variant: "default",
        class:
          "disabled:border-gray-300 disabled:bg-gray-300 disabled:text-white dark:disabled:border-gray-400 dark:disabled:bg-gray-400",
      },
      {
        variant: ["outline", "ghost", "link"],
        class:
          "disabled:border-gray-300 disabled:text-gray-300 dark:disabled:border-gray-400 dark:disabled:text-gray-400",
      },
    ],
    defaultVariants: {
      variant: "default",
      size: "default",
      color: "secondary",
    },
  },
);
